import {APP_INITIALIZER, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {MenubarModule} from 'primeng/menubar';
import {ButtonModule} from 'primeng/button';
import {GraphQLModule} from './graphql.module';
import {HttpClientModule} from '@angular/common/http';
import {InputTextModule} from 'primeng/inputtext';
import {ConfirmationService, MessageService, SharedModule} from 'primeng/api';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {environment} from '../environments/environment';
import {AppAuthGuard} from './guard/app-auth.guard';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgxUiLoaderHttpModule, NgxUiLoaderModule, NgxUiLoaderRouterModule} from 'ngx-ui-loader';
import {LottieModule} from 'ngx-lottie';
import player from 'lottie-web';
import {SharedlModule} from './shared/sharedl.module';
import {CalendarModule, DateAdapter} from 'angular-calendar';
import {adapterFactory} from 'angular-calendar/date-adapters/date-fns';
import {FormsModule} from '@angular/forms';
import {NumericCellEditorComponent} from './ag-grid/numeric-cell-editor/numeric-cell-editor.component';
import {InputNumberModule} from 'primeng/inputnumber';
import {AgGridModule} from './ag-grid/ag-grid.module';
import {ApiModule} from './api/api.module';
//import {NgxPrintModule} from 'ngx-print';
import {NgxPermissionsModule, NgxPermissionsService} from 'ngx-permissions';
import {SidebarModule} from 'primeng/sidebar';
import {PanelMenuModule} from 'primeng/panelmenu';
import {DividerModule} from 'primeng/divider';
import {Router} from '@angular/router';
import {ConfirmDialogModule} from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

function initializeKeycloak(keycloak: KeycloakService, ngxPermissionsService: NgxPermissionsService): () => Promise<void | boolean> {
  return () =>
    keycloak.init({
      config: {
        url: environment.keyCloak_url,
        realm: environment.keyCloak_realm,
        clientId: environment.keyCloak_client
      },
      initOptions: {
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri:
          window.location.origin + '/assets/silent-check-sso.html',
      },
      bearerExcludedUrls: ['https://kingscoop.blob.core.windows.net']
      // initOptions: {
      //   onLoad: 'login-required',
      //   checkLoginIframe: false
      // }
    }).then(async m => {
      console.log(window.location.href);
      if (await keycloak.isLoggedIn()) { ngxPermissionsService.loadPermissions(keycloak.getUserRoles(true)); }
      else {
        if (!window.location.href.includes('registration')) {
          await keycloak.login();
        }
      }
    });
}

async function initializeNgxPermissionService(keycloakService: KeycloakService, ps: NgxPermissionsService): Promise<void> {
  return new Promise(async (resolve, reject) => {
    if (await keycloakService.isLoggedIn()) {
      keycloakService.getKeycloakInstance().loadUserInfo().then((data: any) => ps.loadPermissions(data.Roles));
    }
  });
}

export function playerFactory(): any {
  return player;
}


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    ToastModule,
    BrowserModule,
    BrowserAnimationsModule,
    AgGridModule,
    AppRoutingModule,
    MenubarModule,
    ButtonModule,
    GraphQLModule,
    HttpClientModule,
    SharedModule,
    InputTextModule,
    KeycloakAngularModule,
    FormsModule,
    LottieModule.forRoot({player: playerFactory}),
    NgxUiLoaderModule,
    NgxUiLoaderRouterModule,
    NgxUiLoaderHttpModule.forRoot(
      {
        showForeground: true,
        exclude: ['api/survey/UpsertAuditSilent', `api/survey/CreateAuditSilent`],
      },
    ),
    ApiModule.forRoot({rootUrl: environment.api_url}),
    SharedlModule,
    CalendarModule.forRoot({
      provide: DateAdapter,
      useFactory: adapterFactory,
    }),
    InputNumberModule,
    //NgxPrintModule,
    // https://stackoverflow.com/questions/52815417/ngxpermissions-not-working-with-lazy-loaded-module
    NgxPermissionsModule.forRoot(),
    SidebarModule,
    PanelMenuModule,
    DividerModule,
    ConfirmDialogModule
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService, NgxPermissionsService],
    },
    AppAuthGuard,
    ConfirmationService,
    MessageService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
